import { useNavigate } from "react-router-dom";
import Modal from "../../../../components/portal/Modal";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";
import successIcon from "../../../../assets/icons/successIcon.svg";
import GradientButton from "../../../../components/UI/buttonUI/GradientButton";
import GrayButton from "../../../../components/UI/buttonUI/GrayButton";

export function ConfirmCheckReading({
  loading,
  successResponse,
  formError,
  setFormError,
  setConfirmType,
  vehicleDetails,
  confirmType,
  checkVehicleReading,
}) {
  const navigate = useNavigate();

  return (
    <Modal
      onClose={
        loading || successResponse ? undefined : () => setConfirmType(null)
      }
      modalWidth={`${
        successResponse ? "max-w-sm" : "max-w-lg"
      } w-11/12 max-sm:w-[95%] max-md:p-4 pb-8 pt-7 px-8`}
    >
      <>
        {successResponse ? (
          <div className="text-center">
            <img src={successIcon} alt="success" className="mx-auto w-9 mb-2" />
            <p className="py-5">
              Successfully {confirmType ? "Accepted" : "Rejected"}
            </p>
            <GradientButton
              btnText="Ok"
              width="w-26"
              onClick={() => navigate(0)}
            />
          </div>
        ) : (
          <>
            {formError && (
              <ErrorDisplay
                message={formError}
                closeAction={() => setFormError("")}
              />
            )}
            <p className="text-sm text-gray-600 mt-3 mb-5">
              Are you sure you want to{" "}
              <span className="font-semibold text-gray-800">
                {confirmType ? "Accept" : "Reject"}
              </span>{" "}
              the vehicle reading for{" "}
              <span className="font-semibold text-gray-800">
                {vehicleDetails?.vehicleNumber}
              </span>
              ?
            </p>
            {/* Buttons */}
            <div className="flex justify-end gap-3 items-center">
              <GrayButton
                btnText="Cancel"
                onClick={() => setConfirmType(null)}
                disabled={loading}
              />
              <GradientButton
                btnText={loading ? "Checking..." : "Confirm"}
                disabled={loading}
                onClick={checkVehicleReading}
              />
            </div>
          </>
        )}
      </>
    </Modal>
  );
}
